import React from 'react';
import { X, Printer } from 'lucide-react';
import { OrderTicket, type OrderTicketData } from './OrderTicket';
import { getPrinterConfig } from '../../hooks/usePrinterConfig';
import { Modal } from '../ui';

interface Props {
  data: OrderTicketData | null;
  onClose: () => void;
}

export function OrderTicketModal({ data, onClose }: Props) {
  const paperWidth = getPrinterConfig().paperWidth;
  if (!data) return null;

  return (
    <>
      <style>{`
        @media print {
          @page { size: ${paperWidth}mm auto; margin: 0; }
          html, body { width: ${paperWidth}mm !important; margin: 0 !important; padding: 0 !important; }
          body > * { visibility: hidden !important; }
          #order-ticket-print, #order-ticket-print * { visibility: visible !important; }
          #order-ticket-print {
            position: fixed !important; top: 0 !important; left: 0 !important;
            width: ${paperWidth}mm !important; box-shadow: none !important; border: none !important;
            z-index: 99999 !important;
          }
        }
      `}</style>

      <Modal open={!!data} onClose={onClose} titleId="order-ticket-title" className="max-w-sm">
        <div className="flex items-center justify-between border-b border-border px-5 py-4">
          <h2 id="order-ticket-title" className="text-base font-semibold text-text">Comanda para cocina</h2>
          <button onClick={onClose} className="flex h-8 w-8 items-center justify-center rounded-full hover:bg-muted/50" aria-label="Cerrar">
            <X size={16} />
          </button>
        </div>

        <div className="max-h-[60vh] overflow-y-auto bg-gray-100 px-4 py-4 flex justify-center">
          <div id="order-ticket-print" className="shadow-lg" style={{ background: 'white', border: '1px solid #ddd' }}>
            <OrderTicket data={data} />
          </div>
        </div>

        <div className="flex gap-3 border-t border-border px-5 py-4">
          <button
            onClick={() => window.print()}
            className="flex flex-1 items-center justify-center gap-2 rounded-xl bg-primary px-4 py-2.5 text-sm font-semibold text-white hover:opacity-90"
          >
            <Printer size={16} /> Imprimir comanda
          </button>
          <button onClick={onClose} className="rounded-xl border border-border px-4 py-2.5 text-sm font-medium text-text-muted hover:bg-muted/30">
            Cerrar
          </button>
        </div>
      </Modal>
    </>
  );
}

export default OrderTicketModal;
